
import React, { useState, useRef, useEffect } from "react";
import "./contact.css";
import Header, { Footer } from "../HomePage/header";
import { useNotification } from "../Notification/notification";
import API_URL from "../../config/api";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
 const { notify } = useNotification();
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // ✅ Validation
    if (!formData.name || !formData.email || !formData.message) {
      notify("Please fill all fields ❌", "error");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${API_URL}/api/email/send-email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        notify("Message sent successfully! ✅", "success");

        // ✅ Clear form
        setFormData({
          name: "",
          email: "",
          message: "",
        });
      } else {
        notify(data.error || "Failed to send message ❌", "error");
      }
    } catch (err) {
      console.error(err);
      notify("Server error, please try again ❌", "error");
    } finally {
      setLoading(false);
    }
  };

  const [isCompact, setIsCompact] = useState(false);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;

      if (currentScroll > lastScrollY.current && currentScroll > 50) {
        setIsCompact(true);
      } else {
        setIsCompact(false);
      }

      lastScrollY.current = currentScroll;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Header />

      <div className="contact-container">
        {/* Header */}
        <div className="contact-hero">
          <h1>Contact Us</h1>
          <p>We’d love to hear from you. Get in touch with us.</p>
        </div>

        {/* Content */}
        <div className="contact-content">
          {/* Form */}
          <form className="contact-form" onSubmit={handleSubmit}>
            <h2>Send Message</h2>

            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <textarea
              name="message"
              placeholder="Your Message"
              rows="5"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>

            <button type="submit" disabled={loading}>
              {loading ? "Sending..." : "Send Message"}
            </button>
          </form>

          {/* Contact Info */}
          <div className="contact-info">
            <h2>Contact Information</h2>
            <p>
              <strong>Phone:</strong> +977-9869838769
            </p>
            <p>
              <strong>Email:</strong> sulavsewa4@gmail.com
            </p>
            <p>
              <strong>Address:</strong> Kathmandu, Nepal
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}